import jsCookie from 'js-cookie';
import { isServerRender, serverDocument as document } from '@/util/env';

/**
 * 重写js-cookie的方法，以兼容服务端渲染
 */

function getCookie(key) {
  const name = `${key}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length); // 移除空格
    if (c.indexOf(name) === 0) {
      const value = c.substring(name.length, c.length);
      return decodeURIComponent(value);
    }
  }
  return null;
}
const cookie = {
  ...jsCookie,
  get(name) {
    if (isServerRender) {
      return getCookie(name);
    }
    return jsCookie.get(name);
  },
};


export default cookie;




// WEBPACK FOOTER //
// ../src/util/cookie.js